import { render, staticRenderFns } from "./regionalResources.vue?vue&type=template&id=17d01eea&scoped=true&"
import script from "./regionalResources.vue?vue&type=script&lang=js&"
export * from "./regionalResources.vue?vue&type=script&lang=js&"
import style0 from "./regionalResources.vue?vue&type=style&index=0&id=17d01eea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d01eea",
  null
  
)

export default component.exports